<template>
	<div class="product-single-hover- border rounded h-100 bg-white" :class="itemLayout == 'horizontal' ? 'row' : ''">
		<div class="inline_product clickable d-flex justify-content-center"
			:class="itemLayout == 'horizontal' ? 'w-25' : ''" style="cursor: pointer;background:#3b71de10;"
			:style="imageStyle">
			<div class="d-flex justify-content-end for-dicount-div-null">
				<span class="for-discoutn-value-null"></span>
			</div>
			<div class="d-flex d-block" style="cursor: pointer;">
				<a :href="`/${routeProductPath}/${product.id}`">
					<el-image :src="imgProxy(product.image_url, rs = 'fill:250:250:1')"
						:alt="dt(product?.name_translations)" style="width: 100%; max-width: 250px" :style="imageStyle">
						<template #error>
							<img src="/static/assets/front-end/img/image-place-holder.png"
								:alt="dt(product?.name_translations)" style="width: 100%;">
						</template>
					</el-image>
				</a>
			</div>
		</div>
		<div class="single-product-details position-relative p-2" :class="itemLayout == 'horizontal' ? 'w-75' : ''"
			:style="contentStyle">
			<div class="text-left text-truncate-3">
				<a :href="`/${routeProductPath}/${product.id}`">
					{{ dt(product.name_translations) }}
				</a>
			</div>
			<div v-if="product?.price_range && !hidePricing" class="justify-content-between text-center pt-2">
				<div v-if="!hiddenPrice" class="product-price text-center">
					<span v-if="product.store_type == 'wholesale' && product.account_is_subscribe" class="text-accent">
						{{ aliasTranslations?.sale_price || t("products.wholesalePrice") }}
						{{ priceRange(product.price_range, "sale_price") }}
					</span>
					<span v-else-if="product.store_type == 'wholesale' && !product.account_is_subscribe"
						class="text-accent">
						{{ aliasTranslations?.sale_price || t("products.daigouPrice") }}
						{{ priceRange(product.price_range, "comm_price") }}
					</span>
					<span v-else-if="product.store_type == 'deal'" class="text-accent">
						{{ aliasTranslations?.sale_price || t("products.purchasePrice") }}
						{{ priceRange(product.price_range, "discounted_price") }}
					</span>
					<span v-else class="text-accent">
						{{ aliasTranslations?.sale_price || t("products.salePrice") }}
						{{ priceRange(product.price_range, "sale_price") }}
					</span>
				</div>
				<template v-if="!!displayCoinReward">
					<div class="d-flex align-items-center text-warning">
						<img src="/static/images/coin.png" class="mr-2" style="max-height: 30px" alt="owner_coin_reward">
						{{ priceRange(product.price_range, "owner_coin_reward", "", true) }}1
					</div>
				</template>
			</div>
		</div>
	</div>
</template>

<script setup>
import { reactive, ref, computed } from 'vue'
import { useI18n } from "vue-i18n"
import { dataTranslations as dt, priceRange, imgProxy, lookupAliasTranslations } from "../../utils"

const props = defineProps({
	product: Object,
	itemLayout: { type: String, default: "vertical" },
	storeData: Object,
})

const { t, n, locale } = useI18n()

const hiddenPrice = computed(() => !!props.storeData?.settings?.hidden_price)
const hiddenCart = computed(() => !!props.storeData?.settings?.hidden_cart)
const hiddenContact = computed(() => !!props.storeData?.settings?.hidden_contact)
const aliasTranslations = computed(() => lookupAliasTranslations(props.storeData?.alias_translations, locale.value))
const displayCoinReward = computed(() => props.product?.display_coin_reward && props.product?.price_range?.min_owner_coin_reward > 0)
const contentStyle = computed(() => {
	if (props.itemLayout == "horizontal") {
		return {
			borderRadius: '0px 5px 5px 0px',
		}
	}
	return {
		// minHeight: displayCoinReward.value ? '180px' : '150px',
		paddingTop: '10px',
		borderRadius: '0px 0px 5px 5px',
	}
})
const imageStyle = computed(() => {
	if (props.itemLayout == "horizontal") {
		return {
			borderRadius: '5px 0px 0px 5px',
		}
	}
	return {
		borderRadius: '5px 5px 0px 0px',
	}
})

const AIBWebsiteType = computed(() => window.AIBWebsiteType);
const hidePricing = computed(() => AIBWebsiteType.value === 'saas');
const routeProductPath = computed(() => AIBWebsiteType.value === 'saas' ? 'apps' : 'products');

</script>